import type MockAdapter from 'axios-mock-adapter/types';
import { cartMockData } from './cart.mock';

export const paymentOptionsMock = [
  {
    id: 'banking',
    available: true,
    paymentOptions: [
      {
        id: 'tatrapay',
        available: true,
        errors: [],
        goPay: false,
        recurrence: false,
      },
      {
        id: 'slsp',
        available: true,
        errors: [],
        goPay: true,
        recurrence: false,
      },
      {
        id: 'vubeplatby',
        available: true,
        errors: [],
        goPay: false,
        recurrence: false,
      },
      {
        id: 'unicredit',
        available: true,
        errors: [],
        goPay: true,
        recurrence: false,
      },
      {
        id: 'postova',
        available: true,
        errors: [],
        goPay: true,
        recurrence: false,
      },
      {
        id: 'csob',
        available: true,
        errors: [],
        goPay: true,
        recurrence: false,
      },
    ],
  },
  {
    id: 'card',
    available: true,
    paymentOptions: [
      {
        id: 'new-card',
        available: true,
        errors: [],
        bankName: null,
        cardName: null,
        number: null,
        default: false,
        expiryAt: null,
        recurrence: true,
        recurrenceState: false,
        recurrenceCanBeChanged: true,
      },
      {
        id: 'card-id456',
        available: true,
        errors: [],
        bankName: 'comfortpay',
        cardName: 'Bezodna kreditka',
        number: '1234********5278',
        issuer: 'visa',
        default: false,
        expiryAt: '2026-03-14T11:47:25.481Z',
        oldOtpBank: true,
        recurrence: true,
        recurrenceState: false,
        recurrenceCanBeChanged: true,
      },
      {
        id: 'card-id789',
        available: true,
        errors: [],
        bankName: 'comfortpay',
        cardName: null,
        number: '1234********5278',
        issuer: 'visa',
        default: false,
        expiryAt: '2024-05-14T11:47:25.481Z',
        oldOtpBank: false,
        recurrence: true,
        recurrenceState: false,
        recurrenceCanBeChanged: true,
      },
      {
        id: 'card-id123',
        available: true,
        errors: [],
        bankName: null,
        cardName: 'Firemna 2FRESH',
        number: '1234********5678',
        issuer: 'mastercard',
        default: false,
        expiryAt: '2022-09-14T11:47:25.481Z',
        recurrence: true,
        recurrenceState: false,
        recurrenceCanBeChanged: true,
      },
    ],
  },
  {
    id: 'credit',
    available: true,
    paymentOptions: [
      {
        id: 'credit',
        available: true,
        errors: ['insufficient_credit'],
        credit: '0.00',
        recurrence: false,
      },
    ],
  },
  {
    id: 'transfer',
    available: true,
    paymentOptions: [
      {
        id: 'tatrabanka',
        available: true,
        errors: [],
        bank: 'tatrabanka',
        account: '2620845396 / 1100',
        iban: 'SK35 1100 0000 0026 2084 5396',
        swift: 'TATRSKBX',
        invoiceId: null,
        invoiceVariable: null,
        payBySquare: true,
        payBySquareImageUrl: '',
        recurrence: false,
      },
      {
        id: 'vub',
        available: true,
        errors: [],
        bank: 'vub',
        account: '1878949155 / 0200 ',
        iban: 'SK41 0200 0000 0018 7894 9155',
        swift: 'SUBASKBX',
        invoiceId: null,
        invoiceVariable: null,
        payBySquare: true,
        payBySquareImageUrl: '',
        recurrence: false,
      },
    ],
  },
  {
    id: 'later',
    available: true,
    paymentOptions: [
      {
        id: 'later',
        available: true,
        errors: [],
        recurrence: false,
      },
    ],
  },
];

export const cardPaymentOptionsMock = [
  {
    id: 'new-card',
    available: true,
    errors: [],
    bankName: null,
    cardName: null,
    number: null,
    issuer: null,
    default: false,
    expiryAt: null,
    recurrence: true,
    recurrenceState: false,
    recurrenceCanBeChanged: true,
  },
  {
    id: 'card-id123',
    available: true,
    errors: [],
    bankName: null,
    cardName: null,
    number: '1234********5678',
    issuer: 'mastercard',
    default: false,
    expiryAt: '2022-09-14T11:47:25.481Z',
    recurrence: true,
    recurrenceState: false,
    recurrenceCanBeChanged: true,
  },
];

export const bankingPaymentOptionsMock = [
  {
    id: 'tatrapay',
    available: true,
    errors: [],
    bankName: 'Tatra banka',
  },
  {
    id: 'slsp',
    available: true,
    errors: [],
    bankName: 'Slovenská sporiteľňa',
  },
  {
    id: 'csob',
    available: false,
    errors: ['unavailable'],
    bankName: 'ČSOB',
  },
];

export const paymentOptionsFailMock = {
  type: '/errors/validation',
  status: 422,
  title: 'The given data was invalid.',
  violations: [
    {
      propertyPath: 'optionId',
      errors: [
        {
          translationKey: 'validation.payment_option.insufficient',
        },
      ],
    },
  ],
  data: {
    groupId: 'credit',
    optionId: 'credit',
  },
  failedRules: {
    optionId: {
      propertyPath: 'optionId',
      rules: [
        {
          rule: 'websupport\\cart\\rules\\paymentoption\\issufficientrule',
          parameters: [],
        },
      ],
    },
  },
};

export function registerPaymentOptionsMocks(mock: MockAdapter) {
  // Write a message to console as developer notice
  console.info('Registering payment options API mocks');

  mock.onGet(/\/api\/payment-options/).reply(200, paymentOptionsMock);
  mock.onPut(/\/cart\/payment-option/).reply(200, cartMockData);
}
